export default __webpack_public_path__ + "static/media/10_FOB.74de50bb.svg";